import DialogHeader from './DialogHeader'

export { DialogHeader }
export default DialogHeader
